import { createPortal } from "react-dom";

export default function GridLoadingPanel({
  isLoading,
}: {
  isLoading: boolean;
}) {
  if (!isLoading) {
    return <div />;
  }

  const loadingPanel = (
    <div className="k-loading-mask">
      <span className="k-loading-text">Loading</span>
      <div className="k-loading-image" />
      <div className="k-loading-color" />
    </div>
  );

  const gridContent = document && document.querySelector(".k-grid-content");
  return gridContent ? createPortal(loadingPanel, gridContent) : loadingPanel;
}
